import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=7128ca79&"
import script from "./ResultsTable.vue?vue&type=script&lang=js&"
export * from "./ResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/declan/code/fourpointzero/portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VFlex,VIcon,VLayout,VProgressCircular})
